import { render, staticRenderFns } from "./EditMatrixPrices.vue?vue&type=template&id=01f4e75a"
import script from "./EditMatrixPrices.vue?vue&type=script&lang=js"
export * from "./EditMatrixPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports